// @ts-nocheck
import React from 'react'
import * as R from 'ramda'
import cx from 'classnames'

import { LoaderRow } from 'components/shared/Table/common/LoaderRow/LoaderRow'
import { PlaceholderRow } from 'components/shared/Table/common/PlaceholderRow/PlaceholderRow'

import styles from './TableBody.module.scss'

export const TableBody = ({
  children,
  className = undefined,
  placeholder,
  isLoaded,
}) => {
  const hasChildren = R.gt(R.length(children), 0)

  return (
    <tbody className={cx(styles.body, { [className]: Boolean(className) })}>
      {!isLoaded && <LoaderRow />}
      {isLoaded && !hasChildren && <PlaceholderRow placeholder={placeholder} />}
      {isLoaded && hasChildren && children}
    </tbody>
  )
}
